<template>
  <div class="items ">
    <div class="column-between test">
      <div class="top">
        {{ Data.title }}
      </div>
      <div class="middle row">
        <el-image
          :src="$domain + 'static/noten/website/newHome/top_banner1.png'"
          alt="编程"
          style="width: 180px;height: 120px;border-radius: 14px;"
        ></el-image>
        <div class="intro">
          <div class="record">
            <div class="row">
              <div class="row">
                <div class="center-just" style="height: 28px;">
                  <el-image
                    :src="$domain + 'static/noten/website/creation/look.png'"
                    alt="少儿编程"
                    style="width: 14px;height: 10px;"
                  ></el-image>
                </div>
                <div
                  class="center-just"
                  style="margin-left: 5px;line-height: 28px;"
                >
                  {{ Data.read_num }}
                </div>
              </div>
              <div class="row" style="margin-left: 21px;">
                <div class="center-just" style="height: 28px;">
                  <el-image
                    :src="$domain + Data.cover"
                    alt="少儿编程"
                    style="width: 11px;height: 11px;"
                  ></el-image>
                </div>
                <div
                  class="center-just"
                  style="margin-left: 5px;line-height: 28px;"
                >
                  {{ Data.likes_num }}
                </div>
              </div>
            </div>
          </div>
          <div class="context">
            {{ Data.introduction }}
          </div>
        </div>
      </div>
      <div class="bar"></div>
      <div class="bottom between">
        <div class="look" @click="toPath">
          <div class="btn center-just">查看全文</div>
        </div>
        <div class="time between">
          <div class="row">
            <el-image
              :src="$domain + 'static/noten/website/creation/author.png'"
              alt="编程"
              style="width: 11px;height: 13px;margin-right: 5px;align-self: center;"
            ></el-image>
            次元口袋编程社区
          </div>
          <div>{{ Data.create_time }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { videoCourseList } from "@/api/port";
export default {
  props: ["Data"],
  data() {
    return {
      tid: "",
      hourList: []
    };
  },
  methods: {
    toPath() {
      // videoCourseDetail
      let routeOne = this.$router.resolve({
        name: "videoCourseDetail",
        query: {
          tid: 1
        }
      });
      window.open(routeOne.href, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.test {
  margin: 0px 30px 0px 30px;
}
.items {
  width: 723px;
  height: 290px;
  background: #ffffff;
  border-radius: 10px;
  margin-bottom: 30px;
  // margin: 0px 30px 0px 30px;
  // display: inline-block;
  .top {
    height: 68px;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #1a1a1a;
  }
  .middle {
    min-height: 120px;
    padding: 0px 0px 30px 0px;
    .intro {
      margin-left: 30px;
      .context {
        width: 454px;
        height: 54px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #1a1a1a;
        margin-top: 10px;
      }
    }
  }
  .bar {
    width: 660px;
    height: 1px;
    background: #f2f2f2;
  }
  .bottom {
    display: flex;
    align-items: center;
    height: 71px;
    .look {
      width: 55%;
      height: 100%;
      display: flex;
      align-items: center;
      .btn {
        width: 100px;
        height: 30px;
        background: #1dc2ff;
        border-radius: 4px;
        font-weight: 400;
        color: #ffffff;
        font-size: 14px;
        font-family: Microsoft YaHei;
        caret-color: transparent;
        cursor: pointer;
      }
    }
    .time {
      width: 45%;
      height: 100%;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #1a1a1a;
      display: flex;
      align-items: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/message/components/messages.vue